export const BADGE_SHAPE = {
	base:   'badge--base',
	pill:   'badge--pill',
	pillSm: 'badge--pill badge--sm',
};

export const BADGE_VARIANT = {
	softBlue:    'badge--soft-blue',
	softGray:    'badge--soft-gray',
	softGreen:   'badge--soft-green',
	softOrange:  'badge--soft-orange',
	softRed:     'badge--soft-red',
	softViolet:  'badge--soft-violet',
	softWarm:    'badge--soft-warm',
	softLime:    'badge--soft-lime',
	softPetrol:  'badge--soft-petrol',

	infoBlue:    'badge--info-blue',
	infoGray:    'badge--info-gray',
	infoGreen:   'badge--info-green',
	infoOrange:  'badge--info-orange',
	infoRed:     'badge--info-red',
	infoViolet:  'badge--info-violet',
	infoWarm:    'badge--info-warm',
	infoLime:    'badge--info-lime',
	infoPetrol:  'badge--info-petrol',

	solidBlue:   'badge--solid-blue',
	solidGray:   'badge--solid-gray',
	solidGreen:  'badge--solid-green',
	solidOrange: 'badge--solid-orange',
	solidRed:    'badge--solid-red',
	solidViolet: 'badge--solid-violet',
	solidWarm:   'badge--solid-warm',
	solidLime:   'badge--solid-lime',
	solidPetrol: 'badge--solid-petrol',

	disable:     'badge--disable',
};
